
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";





class ChargeService {
    addChargeEtat(chargeModel) {
        return api.post(UtilsUrl.chargeEtatURL() + "/addChargeEtat", chargeModel);
    }
    getChargeEtat(idUser, month, year,magasinId) {
        return api.get(UtilsUrl.chargeEtatURL() + "/getListChargeEtat/" + idUser + "/" + year + "/" + month+ "/" + magasinId);
    }
    attachedStore(idUser,idCharge,magasinId) {
        return api.get(UtilsUrl.chargeEtatURL() + "/attachedStore/" + idUser + "/" + idCharge +  "/" + magasinId);
    }

    getChargeEtatByIdAndSociete(idUser,idCharge) {
        return api.get(UtilsUrl.chargeEtatURL() + "/getChargeEtatByIdAndSociete/" + idUser + "/" + idCharge);
    }
    getChargePayementInformation(idUser,idCharge) {
        return api.get(UtilsUrl.chargeEtatURL() + "/getChargePayementInformation/"+ idUser + "/"  + idCharge);
    }
    payCharge(payementModel) {
        return api.post(UtilsUrl.chargeEtatURL() + "/payCharge", payementModel);
    }

    uploadQuitance(payementModel) {
        return api.post(UtilsUrl.chargeEtatURL() + "/setFileUploadedURL", payementModel);
    }

    uploadFileDownloaded(payementModel) {
        return api.post(UtilsUrl.chargeEtatURL() + "/setFileDownloadedURL", payementModel);
    }

}
export default new ChargeService()